import { Box, Typography, useMediaQuery } from "@mui/material"
import VibioGetStartedForm from "../hero/VibioGetStartedForm"

export default function FinalCTASection() {
    const isMobile = useMediaQuery('(max-width:950px)')

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                m: isMobile ? '1.2rem .8rem' : '4rem 14vw',
                p: isMobile ? '2rem 1.2rem' : '3rem 6vw',
                fontFamily: 'Catamaran',
            }}
        >
            <Typography
                variant={isMobile ? 'h4' : 'h3'}
                component="h2"
                sx={{
                    fontFamily: 'inherit',
                    fontWeight: 900,
                    color: 'primary.black',
                    mb: 1.5,
                    fontSize: isMobile ? '1.8rem' : '2.2rem',
                    textAlign: 'center',
                }}
            >
                Your link in bio, in a video.
            </Typography>
            <Typography
                variant="body1"
                component="p"
                sx={{
                    fontFamily: 'inherit',
                    fontWeight: 500,
                    color: 'text.gray',
                    mb: 4,
                    fontSize: '1.1rem',
                }}
            >
                a link in bio that gives you the insights that really matter
            </Typography>
            <VibioGetStartedForm />
        </Box>
    )
}
